(function () {
    function refresh(radios, groups) {
        const selected = Array.from(radios).find(function (radio) {
            return radio.checked;
        });
        const mode = selected ? selected.value : null;
        const locked = radios[0].disabled;

        groups.forEach(function (group) {
            const shown = group.getAttribute('data-reverse-logistics-mode').split(' ').includes(mode);
            group.hidden = !shown;
            group.querySelectorAll('input, select, textarea').forEach(function (input) {
                input.disabled = locked || !shown;
            });
        });
    }

    function init() {
        const radios = document.querySelectorAll('[data-reverse-logistics-mode-switch] input[type="radio"]');
        if (radios.length === 0) {
            return;
        }

        const groups = document.querySelectorAll('[data-reverse-logistics-mode]');
        radios.forEach(function (radio) {
            radio.addEventListener('change', function () {
                refresh(radios, groups);
            });
        });
        refresh(radios, groups);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
